module.exports = __webpack_public_path__ + "img/proyecto_14_mv.323c7c57.png";